import { generateClient } from 'aws-amplify/api';
import { createAuditEvent } from '../graphql/mutations';

/**
 * Write an audit event. Identity + createdAt are stamped server-side by the
 * AuditEvent model (owner auth + auto timestamp). Never throws — a failed audit
 * write must not break quote/config flows; it logs and resolves null.
 *
 * @param {{eventType: string, artifactType: string, quoteSerial?: string|null,
 *          vendor: string, payload?: object}} event
 */
export async function recordAuditEvent(event) {
  try {
    const client = generateClient();
    const input = {
      eventType: event.eventType,
      artifactType: event.artifactType,
      quoteSerial: event.quoteSerial ?? null,
      vendor: event.vendor,
      payload: JSON.stringify(event.payload ?? {}),
    };
    return await client.graphql({ query: createAuditEvent, variables: { input } });
  } catch (error) {
    console.error('Failed to record audit event:', error);
    return null;
  }
}
